export default __webpack_public_path__ + "static/media/klubaswebp.14cde1b4.webp";